import JSBI from 'jsbi'

// exports for external consumption
export type BigintIsh = JSBI | bigint | string

export enum ChainId {
  SEPOLIA = 11155111,
  ZKSYNCERA = 324,
  ZKTESTNET = 280,
  LINEAZKEVM = 1101,
  LINEA_TESTNET = 59140
}

export enum TradeType {
  EXACT_INPUT,
  EXACT_OUTPUT
}

export enum Rounding {
  ROUND_DOWN,
  ROUND_HALF_UP,
  ROUND_UP
}

export const FACTORY_ADDRESS = {
  [ChainId.SEPOLIA]: '0xC3550497E591Ac6ed7a7E03ffC711CfB7412E57F', //CHANGE THIS
  [ChainId.ZKSYNCERA]: '0xC3550497E591Ac6ed7a7E03ffC711CfB7412E57F', //CHANGE THIS
  [ChainId.ZKTESTNET]: '0xC3550497E591Ac6ed7a7E03ffC711CfB7412E57F', //CHANGE THIS
  [ChainId.LINEAZKEVM]: '0xC3550497E591Ac6ed7a7E03ffC711CfB7412E57F', //CHANGE THIS
  [ChainId.LINEA_TESTNET]: '0xC3550497E591Ac6ed7a7E03ffC711CfB7412E57F' //CHANGE THIS
}

export const INIT_CODE_HASH = '0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f'

export const MINIMUM_LIQUIDITY = JSBI.BigInt(1000)

// exports for internal consumption
export const ZERO = JSBI.BigInt(0)
export const ONE = JSBI.BigInt(1)
export const TWO = JSBI.BigInt(2)
export const THREE = JSBI.BigInt(3)
export const FIVE = JSBI.BigInt(5)
export const TEN = JSBI.BigInt(10)
export const _100 = JSBI.BigInt(100)
export const _997 = JSBI.BigInt(997)
export const _1000 = JSBI.BigInt(1000)

export enum SolidityType {
  uint8 = 'uint8',
  uint256 = 'uint256'
}

export const SOLIDITY_TYPE_MAXIMA = {
  [SolidityType.uint8]: JSBI.BigInt('0xff'),
  [SolidityType.uint256]: JSBI.BigInt('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff')
}
